// 必须从1开始，否则0的话会导致判断失败
let _guid = 1;
function newGUID() {
  return _guid++;
}

export let CallbackMap = {};

function invokeToJscore(apiName, params, callback, isListen, isOffListen) {
  if(typeof WxGameJsCoreNative === 'undefined') {
    return;
  };
  let wvCbkId = 0;
  if (typeof callback === 'function') {
    wvCbkId              = newGUID();
    CallbackMap[wvCbkId] = callback;
  }else if(typeof callback === 'number') {
    wvCbkId = callback;
  }
  let msg = {
    params: {
      'apiName'    : apiName,
      'wvCbkId'    : wvCbkId,
      'isListen'   : isListen,
      'isOffListen': isOffListen,

      'params' : params
    }
  }
  return WxGameJsCoreNative.postMessage(JSON.stringify(msg));  //WxGameJsCoreNative.postMessage是客户端注册的方法
}

export function postMessageToJscore(apiName, params, callback) {
  if(callback) {
    callback.apiName = apiName;
  }
  invokeToJscore(apiName, params, callback, false);
}

export function listenEventToJscore(apiName, callback) {
  if(callback) {
    callback.apiName = apiName;
  }
  invokeToJscore(apiName, {}, callback, true);
}

export function unListenEventToJscore(apiName, callback) {
  if(callback) {
    for(let wvCbkId in CallbackMap) {
      if(CallbackMap[wvCbkId] === callback) {
        delete CallbackMap[wvCbkId];
        invokeToJscore(apiName, {}, wvCbkId, true, true);
      }
    }
  }else{
    let hasEvent = false;
    for(let wvCbkId in CallbackMap) {
      if(CallbackMap[wvCbkId].apiName === apiName) {
        delete CallbackMap[wvCbkId];
        hasEvent = true;
      }
    }
    if(hasEvent) {
      // 注销该apiName下的所有事件，需要改造listen记录记录事件apiName
      invokeToJscore(apiName, {}, null, true, true);
    }
  }
}

export function postMessageToJscoreCbk(apiName, params, data) {
  if(typeof WxGameJsCoreNative === 'undefined') {
    return;
  };
  let msg = {
    params: {
      'apiName': apiName,
      'params' : params,
      'data'   : data
    }
  }
  return WxGameJsCoreNative.postMessage(JSON.stringify(msg));  //WxGameJsCoreNative.postMessage是客户端注册的方法
}